import { cva } from 'class-variance-authority';

const badgeVariants = cva(
  'inline-flex items-center rounded-sm px-1.5 py-0.5 text-xs leading-4 transition-colors focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden',
  {
    variants: {
      variant: {
        neutral: 'bg-muted text-black',
        positive: 'bg-success/20 text-success',
        attention: 'bg-muted text-chart-5',
        negative: 'bg-destructive/10 text-destructive',
        warning: 'bg-primary/20 text-foreground',
        info: 'bg-info-muted text-info',
        discover: 'bg-discover-muted text-discover',
      },
      shape: {
        rectangle: 'rounded-lg',
        pill: 'rounded-3xl',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
);

export { badgeVariants };
